/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Markers_Lists_LabelInputs */



/**
* | output |
* | --- |
* | "Marker lists" |
*
* @param {Iconik_Publish_Markers_Lists_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_markers_lists_label = /** @type {((inputs?: Iconik_Publish_Markers_Lists_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Markers_Lists_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marker lists")
	if (locale === "de") return /** @type {LocalizedString} */ ("Marker lists")
	if (locale === "it") return /** @type {LocalizedString} */ ("Marker lists")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Marker lists")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marker lists")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Marker lists")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Marker lists")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Marker lists")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marker lists")
	return /** @type {LocalizedString} */ ("Marker lists")
});